import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UploadForm from './upload_form';
import '../../../css/data-grid.css';

function FileUpload_popup() {

    const [data, setData] = useState([]);
    const [list, setList] = useState([]);
    const [atchDta, setAtchDta] = useState([]);
    const [head, setHead] = useState([]);
    const [excelData, setExcelData] = useState({});
    const [output, setOutput] = useState([]);
    const [checked, setChecked] = useState('');
    const [replace, setReplace] = useState([]);
    const [changed, setChanged] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('tableData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/excel_upload_resource.do', {
                params: {
                    tableName: sendData.tableName,
                    tableOwner: sendData.tableOwner,
                }
            });
            setData(response.data);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    const callList = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/selectResourceInfoSubjList.do');
            setList(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    }

    const isValidDate = (dateStr, format = 'YYYYMMDD') => {
        if (!/^\d{8}$/.test(dateStr)) return false;
        const year = parseInt(dateStr.substring(0, 4));
        const month = parseInt(dateStr.substring(4, 6));
        const day = parseInt(dateStr.substring(6, 8));
        const date = new Date(year, month - 1, day);
        return (
            date.getFullYear() === year &&
            date.getMonth() + 1 === month &&
            date.getDate() === day
        );
    };

    const uploadCheckValidation = (rowData, rowIndex) => {
        try {
            const getValue = (col) => (rowData[col] || '').toString().trim();
            const OnlyNumpattern = /^[0-9]+$/;
            const wkEndYNpattern = /^[1-2]$/;
            const wkEndReasonpattern = /^[1-3]$/;
            const OesHumanRsrcpattern = /^[1-2]$/;

            let [
                ClinicSbjectCD, Nm, LcnsNO, InhbtntRegNo,
                BeginDE, EndDE,
                ecshgSpclstWkBeginDe, ecshgSpclstWkEndDe,
                wkEndYN, wkEndReason,
                NxndrBeginDE, NxndrEndDE,
                OesHumanRsrcInfo
            ] = [
                'A', 'B', 'C', 'D', 'G', 'H', 'N', 'O', 'P', 'Q', 'R', 'S', 'U'
            ].map(getValue);

            const row = rowIndex + 1;

            const validateDateField = (label, value) => {
                if (value) {
                    if (value.includes('/')) throw new Error(`${row}번째 행: ${label}에서 '/'는 사용할 수 없습니다.`);
                    const numeric = value.replace(/-/g, '');
                    if (!OnlyNumpattern.test(numeric)) throw new Error(`${row}번째 행: ${label}은 숫자형 날짜여야 합니다.`);
                    if (!isValidDate(numeric)) throw new Error(`${row}번째 행: ${label}의 날짜 형식이 잘못되었습니다.`);
                    return numeric;
                }
                return '';
            };

            BeginDE = validateDateField('외상센터 근무시작일', BeginDE);
            EndDE = validateDateField('외상센터 근무종료일', EndDE);
            ecshgSpclstWkBeginDe = validateDateField('전담전문의 근무시작일', ecshgSpclstWkBeginDe);
            ecshgSpclstWkEndDe = validateDateField('전담전문의 근무종료일', ecshgSpclstWkEndDe);
            NxndrBeginDE = validateDateField('국비지급 시작일자', NxndrBeginDE);
            NxndrEndDE = validateDateField('국비지급 종료일자', NxndrEndDE);

            // 필수값 검증
            if (!ClinicSbjectCD) throw new Error(`${row}번째 행: 전문과목은 필수입니다.`);
            if (!Nm) throw new Error(`${row}번째 행: 성명은 필수입니다.`);
            if (!LcnsNO) throw new Error(`${row}번째 행: 면허번호는 필수입니다.`);
            if (!InhbtntRegNo) throw new Error(`${row}번째 행: 주민등록번호는 필수입니다.`);

            // 주민번호 검사
            const regNoClean = InhbtntRegNo.replace(/-/g, '');
            if (!(regNoClean.length === 7 && OnlyNumpattern.test(regNoClean))) {
                throw new Error(`${row}번째 행: 주민등록번호는 7자리 숫자 또는 '######-#' 형식이어야 합니다.`);
            }

            if (!BeginDE) throw new Error(`${row}번째 행: 외상센터 근무시작일은 필수입니다.`);

            // 날짜 간 비교
            if (BeginDE && EndDE && BeginDE > EndDE) {
                throw new Error(`${row}번째 행: 외상센터 근무시작일은 종료일보다 빠를 수 없습니다.`);
            }
            if (ecshgSpclstWkBeginDe && ecshgSpclstWkEndDe && ecshgSpclstWkBeginDe > ecshgSpclstWkEndDe) {
                throw new Error(`${row}번째 행: 전담전문의 근무시작일은 종료일보다 빠를 수 없습니다.`);
            }
            if (NxndrBeginDE && NxndrEndDE && NxndrBeginDE > NxndrEndDE) {
                throw new Error(`${row}번째 행: 국비지급 시작일은 종료일보다 빠를 수 없습니다.`);
            }
            // 코드형 필드 유효성
            if (wkEndYN && !wkEndYNpattern.test(wkEndYN)) {
                throw new Error(`${row}번째 행: 전담전문의 근무종료여부는 1 또는 2로 입력해야 합니다.`);
            }
            if (wkEndReason && !wkEndReasonpattern.test(wkEndReason)) {
                throw new Error(`${row}번째 행: 전담전문의 근무종류사유는 1, 2, 3 중 하나여야 합니다.`);
            }
            if (OesHumanRsrcInfo && !OesHumanRsrcpattern.test(OesHumanRsrcInfo)) {
                throw new Error(`${row}번째 행: 외상수련기관 인력현황은 1 또는 2로 입력해야 합니다.`);
            }
            return true;
        } catch (e) {
            alert(e.message);
            return false;
        }
    };

    const formatDate = (val) => {
        if (!val || val.length !== 8) return val;
        return `${val.substring(0, 4)}-${val.substring(4, 6)}-${val.substring(6, 8)}`;
    };

    const formatResidentNumber = (val) => {
        if (!val) return val;
        const clean = val.toString().replace(/-/g, '');
        if (clean.length === 7) {
            return `${clean.substring(0, 6)}-${clean.substring(6, 7)}`;
        }
        return val;
    };

    const uploadReplaceValue = (row) => {
        try {
            const newRow = { ...row };
            // 주민등록번호 포맷
            if (newRow.D) {
                newRow.D = formatResidentNumber(newRow.D);
            }
            // 날짜 포맷
            newRow.G = formatDate(newRow.G) || ''; // 외상센터 근무 시작일
            newRow.H = formatDate(newRow.H) || ''; // 외상센터 근무 종료일
            newRow.N = formatDate(newRow.N) || ''; // 전담전문의 근무 시작일
            newRow.O = formatDate(newRow.O) || ''; // 전담전문의 근무 종료일
            newRow.R = formatDate(newRow.R) || ''; // 국비지급 시작일자
            newRow.S = formatDate(newRow.S) || ''; // 국비지급 종료일자
            // Y/N → 빈 문자열
            const ynFields = {
                I: '전담 여부',
                J: '국비 여부',
                K: '자비 여부',
                L: '당직비 여부',
                M: 'ON CALL 비',
                T: '전공의 보조인력',
            };
            Object.keys(ynFields).forEach((col) => {
                if (newRow[col] === 'N') {
                    newRow[col] = '';
                }
            });
            return newRow;
        } catch (e) {
            console.error('uploadReplaceValue error:', e);
            alert(`[uploadReplaceValue] 오류: ${e.message}`);
            return row;
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files[0] !== undefined) {
            setAtchDta(e.target.files[0]); //TF로 변경
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'base64' });
                const headers = {};
                Object.keys(wb.SheetNames).forEach((i) => {
                    const wsname = wb.SheetNames[i];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    return headers[wsname] = data[0];
                });
                setChecked(wb.SheetNames[0]);
                setOutput(wb.SheetNames[0]);
                setHead(headers);
                setExcelData(to_json(wb));
                console.log(to_json(wb));
            };
            reader.readAsArrayBuffer(file);
        } else {
            setAtchDta([]);
            setHead([]);
            setExcelData([]);
            setOutput([]);
            setChecked('');
            setChanged([]);
            return;
        }
    };

    const to_json = (workbook) => {
        const result = {};
        workbook.SheetNames.forEach((sn) => {
            const sheet = workbook.Sheets[sn];
            const rows = XLSX.utils.sheet_to_json(sheet, {
                header: 'A',     // 첫 행을 header로 사용
                defval: '',      // 빈 셀은 공백 처리
            });
            if (rows.length > 0) {
                result[sn] = rows;
            }
        });
        return result;
    };

    const initChanged = (head, data) => {
        if (head === undefined) {
            return;
        } else {
            const mapped = head.reduce((acc, row, idx) => {
                const key = String.fromCharCode(65 + idx);
                const item = data.find(item => item.COMMENTS === row);
                const value = item ? item.COLUMN_NAME : '';
                acc[key] = value;
                return acc;
            }, {});
            setChanged(mapped);
        };
    }

    const save = async () => {
        if (atchDta.length === 0) {
            alert('선택된 파일이 없습니다.');
            return false;
        }
        if (changedValid(changed) === 'T') {
            alert('중복 선택한 항목이 있습니다. ');
            return false;
        }
        const real = replace.map((row) => ({
            ...row,
            A: list.filter((i) => i.CD_NM === row.A).map(item => item.CD)[0]
        }));
        real.unshift(changed);
        saveLogic(real, "/trmsapi/obthrc/excel_upload.do");
    };

    const saveLogic = async (data, url) => {
        const payload = new URLSearchParams({
            emogcode: sendData.emogCode,
            excData: JSON.stringify(data),
            userId: localStorage.getItem("id"),
        });

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: payload,
            });

            if (!response.ok) {
                throw new Error(`서버 오류: ${response.status}`);
            }

            const resultText = await response.text();
            console.log('저장 결과:', resultText);

            alert('저장이 완료되었습니다.');
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장에 실패했습니다. 관리자에게 문의하세요.');
        }
    }

    const exit = () => {
        window.close();
    }

    const handelOptions = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...changed,
            [name]: value
        };
        setChanged(newParams);
    };

    const changedValid = (change) => {
        var result = 'F';
        var length = head[checked].length
        for (var i = 0; i < length; i++) {
            var key = change[String.fromCharCode(65 + i)];
            if (Object.values(change).filter((i) => key === i).length > 1) {
                result = 'T';
                break;
            }
        }
        return result;
    }

    useEffect(() => {
        popupData();
        callList();
    }, []);

    useEffect(() => {
        initChanged(head[checked], data);
        const currentSheet = excelData[checked];
        if (!currentSheet || !Array.isArray(currentSheet)) {
            setReplace([]);
            return;
        }
        const processed = currentSheet.slice(1).map((row, Idx) => {
            uploadCheckValidation(row, Idx);
            return uploadReplaceValue(row);
        });
        setReplace(processed);
    }, [excelData]);

    return (
        <UploadForm
            atchDta={atchDta}
            handleFileChange={handleFileChange}
            setChecked={setChecked}
            checked={checked}
            output={output}
            sendData={sendData}
            excelData={excelData}
            replace={replace}
            head={head}
            data={data}
            handelOptions={handelOptions}
            save={save}
            exit={exit}
            title={"전문의"}
            changed={changed}
        />
    );
}


export default FileUpload_popup;